import "./testimonials.scss";

export default function Testimonials() {
  const data = [
    {
      id: 1,
      name: "Quang Dang",
      title: "Software Engineer",
      img:"assets/quan.jpeg",
      icon: "assets/linkedin.png",
      desc:
        "Fantastic person to work with. He was very cooperative, creative and persevering, which made our software team excel.",
      ref: "https://www.linkedin.com/in/quangdang87/",
      
    },
    {
      id: 2,
      name: "Chun Hin Chan",
      title: "Software Developer",
      img:"assets/chan.jpeg",
      icon: "assets/linkedin.png",
      desc:"I have known him since college, and I know how dedicated he can be. He is very passionate about software and technology.",
      featured: true,
      ref: "https://www.linkedin.com/in/chnchan/",
    },
    {
      id: 3,
      name: "Jose Rodriguez",
      title: "Instructional Assistant",
      img:"assets/jose.jpeg",
      icon: "assets/linkedin.png",
      desc: "Not only does he love to learn and create, but he also loves to share what he knows and helps other people who are barely starting out.",
      ref: "https://www.linkedin.com/in/jose-rodriguez-252a7b109/",
    },
  ];
  return (
    <div className="testimonials" id="testimonials">
      <h1>Testimonials</h1>
      <div className="container">
        {data.map((d) => (
          <div className={d.featured ? "card featured" : "card"}>
            <div className="top">
              <img src="assets/right-arrow.png" className="left" alt="" />
              <img
                className="user"
                src={d.img}
                alt=""
              />
              <a href= {d.ref}>
              <img className="right" src={d.icon} alt="" />
              </a>
            </div>
            <div className="center">
              {d.desc}
            </div>
            <div className="bottom">
              <h3>{d.name}</h3>
              <h4>{d.title}</h4>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
